export const SERVER_URL = process.env.REACT_APP_API_URL;
export const API_URL = `${SERVER_URL}/graphql`;

export enum NotificationType {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
}

export enum Statuses {
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  PENDING = 'Pending',
  EXPIRED = 'Expired',
}